import { render, staticRenderFns } from "./ClinicConfirmDialog.vue?vue&type=template&id=3b7f7818&scoped=true"
import script from "./ClinicConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ClinicConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ClinicConfirmDialog.vue?vue&type=style&index=0&id=3b7f7818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f7818",
  null
  
)

export default component.exports